/**
 * Camada fina sobre `api` que conhece o contrato de listagem do cadastro — e é o
 * ÚNICO lugar que o conhece. Os componentes genéricos (ListaRecurso, DrawerCriar,
 * EdicaoRecurso) nunca montam URL nem sabem que a paginação é `limite`/`offset`.
 *
 * Contrato do backend (ver `apps/api/.../cadastro`):
 * - `GET {endpoint}?busca=&limite=&offset=` → `{ itens, total }` (limite ≤ 200).
 * - `POST {endpoint}` → 201 se criou, 200 se reusou um registro de mesmo
 *   identificador forte (dedup). Ambos retornam a entidade com `id`.
 */
import { api, type PaginaCad, type Resposta } from '@/lib/api';

const LIMITE_MAX = 200;

export function listarRecurso<T>(
  endpoint: string,
  p: { busca?: string; tag?: string; filtros?: string; limite?: number; offset?: number },
): Promise<Resposta<PaginaCad<T>>> {
  const qs = new URLSearchParams();
  if (p.busca?.trim()) qs.set('busca', p.busca.trim());
  if (p.tag) qs.set('tag', p.tag);
  if (p.filtros) qs.set('filtros', p.filtros);
  qs.set('limite', String(Math.min(p.limite ?? 50, LIMITE_MAX)));
  qs.set('offset', String(p.offset ?? 0));
  return api.get<PaginaCad<T>>(`${endpoint}?${qs}`);
}

export const obterRecursoPorId = <T>(endpoint: string, id: string) =>
  api.get<T>(`${endpoint}/${id}`);

export const criarRecurso = <T>(endpoint: string, corpo: unknown) => api.post<T>(endpoint, corpo);

export const atualizarRecurso = <T>(endpoint: string, id: string, corpo: unknown) =>
  api.patch<T>(`${endpoint}/${id}`, corpo);

export const removerRecurso = (endpoint: string, id: string) => api.del(`${endpoint}/${id}`);
